import {useUserPreferencesStore} from '../../../../../app/tfi/store/userPreferencesStore'
import {SidebarMenuMainLegacy} from './SidebarMenuMainLegacy'
import {SidebarMenuMainNew} from './SidebarMenuMainNew'

const SidebarMenuMain = () => {
  const sidebarView = useUserPreferencesStore((s) => s.sidebarView)
  return sidebarView === 'new' ? <SidebarMenuMainNew /> : <SidebarMenuMainLegacy />
}

export {SidebarMenuMain}
